import general from './general';
import { locomotivePageInit, pathAnimate } from './functions';

const historyPage = {
    init: function() {
        document.addEventListener('DOMContentLoaded', () => {
            this.historyPageAnimate();
            this.sliderHistoryCards();
            locomotivePageInit();
            pathAnimate();
        });
    },

    historyPageAnimate: function() {
        if ($("#history-1").length === 0) return;

        // читать дальше
        $('.history__item-subtitle_hidden').each(function() {
            $(this).attr('data-height-max', $(this).height());
            $(this).addClass('hide min');
            $(this).attr('data-height-min', $(this).height());
            $(document).trigger('locomotive-update');
        });

        $('.history__read-more').on('click', function() {
            var hiddenText = $(this).closest('.history__hidden-wrapp').find('.history__item-subtitle_hidden'),
                minHeight = hiddenText.data('height-min'),
                maxHeight = hiddenText.data('height-max'),
                textBtnMore = $(this).find('.history__read-more__more'),
                textBtnLess = $(this).find('.history__read-more__less');

            if (hiddenText.hasClass('min')) {
                hiddenText.animate({
                    height: maxHeight
                }, 400, function() {
                    hiddenText.removeClass('min');
                    textBtnMore.hide();
                    textBtnLess.show();
                    $(document).trigger('locomotive-update');
                });
            } else {
                hiddenText.animate({
                    height: minHeight
                }, 400, function() {
                    hiddenText.addClass('min');
                    textBtnMore.show();
                    textBtnLess.hide();
                    $(document).trigger('locomotive-update');
                });
            }
        });
    },

    sliderHistoryCards: function() {
        const history__slider = $('.history__slider');
        if (history__slider.length === 0) return;

        history__slider.each(function() {
            sliderCardInit($(this));
        });

        function sliderCardInit(slider) {
            var items = slider.find($('.history__slider-item')),
                btnNext = slider.find($('[name="next-card"]')),
                btnPrev = slider.find($('[name="prev-card"]')),
                container = slider.find($('.history__slider-container'));
            items.last().addClass('active');

            btnNext.on('click', function() {
                var activeCard = slider.find('.history__slider-item.active');
                activeCard.addClass('hidden').removeClass('active');
                container.find(`.history__slider-item:eq(${activeCard.index() - 1})`).addClass('active');
                setTimeout(function() {
                    activeCard.prependTo(container);
                    activeCard.removeClass('hidden');
                }, 500);
            });

            btnPrev.on('click', function() {
                slider.find('.history__slider-item.active').removeClass('active');
                var currentCard = slider.find('.history__slider-item').first();
                currentCard.addClass('active show');
                currentCard.appendTo(container);
                setTimeout(function() {
                    currentCard.removeClass('show');
                }, 500);
            });
        }
    },
};

general.init();
historyPage.init();
